import React, { createContext } from "react";
import PropTypes from "prop-types";

/**
 * React context for configuration settings.
 * Using a context helps to share configuration data across the component tree.
 */
export const ConfigContext = createContext(null);

/**
 * Component that provides configuration settings to its children.
 *
 * @param {object} props - Component props.
 * @param {object} props.config - The configuration object to provide.
 * @param {React.ReactNode} props.children - The child elements.
 * @returns {React.JSX.Element} The configuration provider component.
 */
export const ConfigProvider = ({ config, children }) => {
	return (
		<ConfigContext.Provider value={config}>
			{children}
		</ConfigContext.Provider>
	);
};

ConfigProvider.propTypes = {
	config: PropTypes.object.isRequired,
	children: PropTypes.node.isRequired,
};
